<template>
  <div class="opple-ability-ui-com-shuanglu-container">
    <p v-if="errorMsg" class="error-msg">
      {{ errorMsg }}
    </p>
    <div class="opple-ability-ui-com-shuanglu">
      <div
        v-for="(modal, index) in singleLampCountModal"
        :key="index"
        class="opple-ability-ui-com-shuanglu_item"
      >
        <span class="opple-ability-ui-com-shuanglu_item_span">{{ $t('projectmsg.channel') }} {{ index + 1 }} </span>
        <el-input-number
          v-model="singleLampCountModal[index]"
          type="text"
          class="shuanglu_input"
          :min="minValue"
          :max="maxValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { NEIGHBOR_GROUP } from '@/utils/enums';
import { getShuangluDeviceInfo } from '@/utils/device';
import {
  SaveOrUpdateCustomData,
  GetCustomDataList
} from "@/axios/IScene.js";
import { warning } from '@/assets/js/common.js'
import { Trace, TRACE_DATA_TYPE_ENUM } from "@utils/trace";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    gpDetails: {
      type: Object,
      default: () => ({})
    },
    device: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      childDeviceCount: 0,
      singleLampCount: '',
      singleLampCountModal: [], 
      errorMsg: '',
    }
  },

  computed: {
    minValue(){
      return this.item.Min || 0
    },
    maxValue(){
      return this.item.Max || 240
    }
    
  },

  mounted() {   
    this.initValue();
  },

  methods: {
    parseChannelBaseline(history) {
      if (!history || !Array.isArray(history.Result) || !history.Result.length) {
        return null;
      }

      const dataStr = history.Result[0] || { Content: '{}' };
      const data = JSON.parse(dataStr.Content || '{}');

      return {
        childDeviceCount: data.childDeviceCount,
        savedByUser: data.savedByUser === true,
      };
    },

    checkChannelCountAnomaly(baseline, current) {
      if (baseline == null || baseline <= current) return;

      const errorIndex = Math.floor(current / 2);

      this.errorMsg = this.$t('deviceMsg.channelCountChanged', { errorIndex });
      warning(this, this.errorMsg);

      Trace({
        data: JSON.stringify({
          VDeviceId: this.device.VDeviceId,
          errorIndex,
          history: baseline,
          current,
        }),
      }, TRACE_DATA_TYPE_ENUM.shuangluTrans);
    },

    saveChannelBaseline(payload) {
      return SaveOrUpdateCustomData([{
        ProjectCode: this.$store.state.projectcode,
        Type: 'MatrixScene',
        Identifier: this.device.VDeviceId,
        Content: JSON.stringify(payload),
      }]);
    },

    async initValue() {  
      const { 
        isShuanglu,
        childDeviceCount,
        singleLampCounts 
      } = getShuangluDeviceInfo(this.gpDetails.GpDetails, this.device);

      if (!isShuanglu) return;

      const history = await GetCustomDataList({
        projectCode: this.$store.state.projectcode,
        type: 'MatrixScene',
        identifier: this.device.VDeviceId,
      });

      const baseline = this.parseChannelBaseline(history);

      if (baseline && baseline.savedByUser) {
        // 用户手动保存过：始终以云端手动基准对比，打开面板不自动改基准
        this.checkChannelCountAnomaly(baseline.childDeviceCount, childDeviceCount);
      } else {
        // 未手动保存：与最近一次上报对比，再写入本次上报（不以历史最高为准，最高那次未必可信）
        const lastReported = baseline ? baseline.childDeviceCount : null;

        this.checkChannelCountAnomaly(lastReported, childDeviceCount);

        await this.saveChannelBaseline({
          childDeviceCount,
          savedByUser: false,
        });
      }

      this.childDeviceCount = childDeviceCount;
      this.singleLampCountModal = singleLampCounts;
    },

    // 校验
    validate() {
      let status = true;

      for (let i = 0; i < this.childDeviceCount; i++) {
        // console.log('this.singleLampCountModal[i]', this.singleLampCountModal[i]);
        
        // if ((this.singleLampCountModal[i] || '').trim() === '') {
        if (!Number.isInteger(this.singleLampCountModal[i])) {
          status = false;
          break;
        }
      }
  
      return {
        status,
        msg: this.$t('projectmsg.fillChannel')
      }
    },

    getData() {
      const baseWalue = `01${('000' + Number(this.childDeviceCount).toString(16)).slice(-4)}`;
      let mainValue = this.singleLampCountModal.map(val => {
        return `0${Number(val).toString(16)}`.slice(-2);
      }).join('');

      return {
        Key: this.item.KeyId,
        Values: [ baseWalue + mainValue ]
      }
    },

    onSave() {
      this.saveChannelBaseline({
        childDeviceCount: this.childDeviceCount,
        savedByUser: true,
      });
    }
  },
};
</script>

<style lang="scss">
.opple-ability-ui-form {
  .opple-ability-ui-com-shuanglu {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    // height: 100px;
    // overflow: scroll;

    &_item {
      display: flex;
      width: 25%;
      margin-bottom: 6px;
      align-items: center;
      justify-content: space-between;
      &_span {
        display: inline-block;
        min-width: 55px;
        padding: 2px 4px;
        border-radius: 3px;
        white-space: nowrap;
        font-size: 12px;
        text-align: center;
        // background-color: #222;
        // color: #fff;
      }
    }

    .shuanglu_input {
      position: relative;
      right: auto;
      max-width: 75px;
    }

    &_unit {
      position: absolute;
      right: -30px;
    }
  }
}

.shuanglu_input .el-input__inner {
  padding: 0 10px;
}

.shuanglu_input {
  .el-input-number__decrease {
    display: none !important;
  }
  .el-input-number__increase {
    display: none !important;
  }
}

.error-msg {
  color: red;
  text-align: right;
}

</style>